import logger from './logger';
// frontend/src/utils/debugLogger.js
// Simple debug logging utility

// Enable/disable debug logging based on environment
const DEBUG_ENABLED = process.env.NODE_ENV === 'development' ||
                      process.env.REACT_APP_DEBUG === 'true' ||
                      localStorage.getItem('debug_enabled') === 'true';

export const debugLog = (...args) => {
  if (DEBUG_ENABLED) {
    logger.debug('[DEBUG]', ...args);
  }
};

// For backward compatibility with existing import paths
export default debugLog;
